import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "../../i18n";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useLanguage();
  
  const faqItems = t('faq.items');
  const faqs = Array.isArray(faqItems) ? faqItems : [
    { question: "¿Cuántos drones se utilizan en un show?", answer: "El número de drones varía según la escala del evento." },
    { question: "¿Qué tan anticipado debo reservar?", answer: "Recomendamos 4-6 semanas de anticipación." },
    { question: "¿Se requieren permisos especiales?", answer: "Sí, NexAir gestiona todos los permisos necesarios." },
    { question: "¿El clima afecta el show?", answer: "Monitoreamos el clima constantemente." },
    { question: "¿Pueden formar cualquier logo?", answer: "Sí, podemos crear cualquier figura o logo." },
  ];

  return (
    <section id="faq" className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4">
            {t('faq.title')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              {t('faq.titleHighlight')}
            </span>
          </h2>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="border border-white/10 rounded-xl overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                className="w-full px-6 py-5 text-left flex items-center justify-between bg-white/5 hover:bg-white/[0.07] transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-white pr-4">{faq.question}</span>
                <ChevronDown 
                  className={`w-5 h-5 text-cyan-400 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-white/[0.02] border-t border-white/10">
                  <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
